// extracted by mini-css-extract-plugin
module.exports = {"innovationListWrapper":"innovationListWrapper_innovationListWrapper__3Ym-0","tag":"innovationListWrapper_tag__a62DP"};